import React from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import Buttons from "../components/Buttons";
import { useState,useEffect, useRef } from "react";
import { mainTable } from "../css/Common";
import TextArea from "../ReusableComponents/TextArea";
import { BindAPI,BindPostAPI } from "../services/APIConnection";
import villaImage from '../image/villa1.jpg';
const OnHoldPopUp = (data) => {

  

  const handleInputChangeForm = (e) => {
    const { name, value } = e.target;
    setHoldFormData((...prevData) => ({ ...prevData, [name]: value }));
  }


  const fieldLabels = {
    onholdreason: { label: "Reason for Hold", type: 'select-one' },
    followdate: { label: "Follow up Date", type: 'date' },
    holdnotes: { label: "Notes", type: 'text' }
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const field = fieldLabels[name];
    console.log(field)
    if (!field) return;
    
    const label = field.label;
    const type = field.type;
    console.log(label)
    console.log(type)

    const message = value.trim() === ''
      ? (type === 'select-one' ? `Select ${label}` : `Enter ${label}`)
      : '';

    setHoldError((prevErrors) => ({
      ...prevErrors,
      [name]: message
    }));
  };
var clientId = sessionStorage.getItem("MstClientId");
const handleSubmit=()=>{}



  const validateForm = (action) => {
    let fieldsToValidate = [];
    const newErrors = {};
    let formValid = true;

    if (action === 'save') {
      fieldsToValidate = ['onholdreason', 'followdate'];
    }

    fieldsToValidate.forEach((key) => {
      const value = holdformData[key] || '';
      const field = fieldLabels[key];

      if (!field) return; // skip unknown fields

      const { label, type } = field;

      if (value.trim() === '') {
        const message = type === 'select-one' ? `Select ${label}` : `Enter ${label}`;
        newErrors[key] = message;
        formValid = false;
      }
    });

    setHoldError(newErrors); // <- make sure this updates your UI
    return formValid;     // <- return the result for the calling function

    if (formValid && action === 'save') {
      console.log("saved");
      //setVisibleAdd(false)
      //setVisibleTable(true);
    }
    else {
      console.log(` Validation failed for "${action}"`);


    }
  };
  const onSave = () => {
    validateForm('save')
  }



  const [holdError, setHoldError] = useState({
    onholdreason: '',
    holdnotes: '',
    followdate: ''
  });

  const handleInputChange = () => { }
  

  var testdta = data;
  console.log(testdta);
  const [holdformData, setHoldFormData] = useState({
    enquiryid: '',
    enquirydate: '',
    fname: "",
    lname: "",
    fromdate: '',
    todate: "",
    onholdreason: '',
    holdnotes: '',
    followdate: ''
  })
  const [holdreasondropdown, setholdreasondropdown] = useState([
    // { value: '1', label: 'Awaiting Customer Confirmation' },
    // { value: '1', label: 'Pending Internal Approval (Corporate)' },
    // { value: '1', label: 'Need to Discuss with Group/Family' },
    // { value: '1', label: 'Hold Requested by Guest' },
    // { value: '1', label: 'Other (With Notes)' }
  ])



    useEffect(() => {
        BindGetEnquiryValues();
      }, []);
    
    const BindGetEnquiryValues = async () => {
      //   
     //    
     
      const data = {
       mstClientId: clientId,
    }

        const response = await BindPostAPI(data,"Enquiry/BindGetEnquiryValues")
        console.log("onlost:", response);
        if (response && response.data) {
          
               
                const HoldReasonId=response.data.Table9.map((item) => ({
                    value: item.MstHoldReasonId,
                    label: item.HoldReason,
                }));
              
                setholdreasondropdown(HoldReasonId)
    
    
        } else {
        
          //setBindEnquiryData([]);
        }
      };


   const checkboxRef = useRef();
  
    const handleClick = () => {
      alert(`Checked: ${checkboxRef.current.checked}`);};

      const numbers=[1,2]
  return (

    <>
      <div className='mx-auto p-8 maxw-7xl'>
        <div className={mainTable.grid3}>
          <InputText
            inputType="text"
            title="Enquiry ID"
            name="enquiryid"
            controlFunc={handleInputChangeForm}
            controlFuncBlur={handleBlur}
            content={"EQ200525-12"}
            placeholder=""
            disabled={true}
            // tabIndex="11"
            isRequired={true}
          />

          <InputText
            inputType="date"
            title="Booking From"
            name="fromdate"
            content={data?.data.fromdate || ''}
            placeholder="Enter street"
            disabled={true}
            // tabIndex="9"
            isRequired={true}

          />
          <InputText
            inputType="date"
            title="Booking To"
            name="todate"
            content={data?.data.todate || ''}
            placeholder="Enter street"
            disabled={true}
            // tabIndex="9"
            isRequired={true}

          />

          <InputText
            inputType="text"
            title="Mobile Number"
            name="number"
            content={data?.data.number || ''}
            placeholder="Enter your mobile number"
            disabled={true}
            // tabIndex="3"
            isRequired={true}
            classStar="text-red-500"
          />

          <InputText
            inputType="text"
            title="First Name"
            name="fname"
            content={data?.data.fname || ''}
            disabled={true}
            // tabIndex="1"
            isRequired={true}
            classStar="text-red-500"
          />

          <InputText
            inputType="text"
            title="Last Name"
            name="lname"
            content={data?.data.lname || ''}
            disabled={true}
            // tabIndex="2"
            isRequired={true}
            classStar="text-red-500"
          />

          <InputText
            inputType="date"
            title="Enquiry Date"
            name="enquirydateonhold"
            controlFunc={handleInputChangeForm}
            controlFuncBlur={handleBlur}
            content={data?.data.enquirydate || ''}
            placeholder="Enter Date"
            disabled={true}
            isRequired={true}

          />

          <DropDown
            name="onholdreason"
            title="Reason for Hold"
            type="select-one"
            options={holdreasondropdown}
            selectedOption={holdformData.onholdreason}
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            placeholder="Select Payment Status"
            isRequired={true}
            // tabIndex="12"
           // errorMessage={holdError.onholdreason}

          />

          <InputText
            inputType="date"
            title="Expected Follow-Update"
            name="followdate"
            controlFunc={handleInputChangeForm}
            controlFuncBlur={handleBlur}
            content={holdformData.followdate}
            placeholder="Enter Date"
            disabled={false}
            // tabIndex="9"
            isRequired={true}
            errorMessage={holdError.followdate}
          />



        </div>

<TextArea title='Notes' name="holdnotes" placeholder="Describe here" rows='3' errorMessage={holdError.holdnotes}
          controlFunc={handleInputChange} controlFuncBlur={handleBlur} isRequired={true} />

        

      </div>
      <div className="h-28 flex justify-center items-center gap-4">
          <div><button  type="button" data-modal-hide="bottom-right-modal" className={mainTable.submitButton} onClick={() => handleSubmit}>Submit</button></div>
          <div><button type="button" className={mainTable.cancelButton} onClick={() => handleSubmit}>Cancel</button></div>
          </div>
    </>
  )
}

export default OnHoldPopUp
